import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import LoginForm from '../components/loginpage/LoginForm';
import axios from 'axios';
import Error from '../components/global/Error';
import Loading from '../components/global/Loading';
import '../styles/login.css';

function LoginPage() {
    const [ credentials, setCredentials ] = useState({
        name: '',
        code: ''
    });
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);
    const navigate = useNavigate();
    const auth = useAuth();
    const { setSession, setUser } = useAuth();

    useEffect(() => {
        if (auth.isAuthenticated) {
            navigate('/');
        }
    }, [auth, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios({
                method: 'post',
                url: `https://signupapp-backend-app-9b09cbe965e9.herokuapp.com/api/restricted/login`,
                data: credentials
            }).then(response => {
                if(response.data.auth) {
                    setUser(response.data.user);
                    setSession(new String(response.data.sessionId));
                    auth.login(() => {
                        navigate('/protected');
                    });
                    setLoading(false);
                } else {
                    setError('Niepoprawne dane logowania.');
                    setLoading(false);
                }
            });
        } catch(error) {
            setError('Niepoprawne dane logowania.');
            setLoading(false);
        };
    };

    return (
        <div className='loginpage'>
            {loading ? <Loading/> : <div className='form'>
                <h2>Azarex B2B Signup App</h2>
                <LoginForm credentials={credentials} setCredentials={setCredentials} handleLogin={handleLogin}/>
                { error && <Error text={error}/> }
            </div>}
        </div>
    );
}

export default LoginPage;
